export const columns = function () {
    // 日期，机构名称，车牌号，被内保人，单号，车辆种类，车损(内保额度），三者(内保额度），每座(内保额度），内保起期，内保止期
    return [
        {
            prop: 'create_time',
            label: '日期',
            minWidth: 200
        },
        {
            prop: 'orgName',
            label: '机构名称',
            minWidth: 100
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'personName',
            label: '被内保人',
            minWidth: 200
        },
        {
            prop: 'bh',
            label: '单号',
            minWidth: 200
        },
        {
            prop: 'carType',
            label: '车辆种类',
            minWidth: 200
        },
        {
            prop: 'carDamage',
            label: '机动车损失内保',
            minWidth: 200
        },
        {
            prop: 'threeDamage',
            label: '第三者责任内保',
            minWidth: 200
        },
        {
            prop: 'driverDamage',
            label: '车上人员责任内保（司机）',
            minWidth: 200
        },
        {
            prop: 'seatDamage',
            label: '车上人员责任内保（乘客）',
            minWidth: 200
        },
		{
		  prop: "medical_tcfee",
		  label: "医保外用药(内保额度）",
		  minWidth: 200,
		},
		{
		  prop: "addDriverDamage",
		  label: "附加司机责任服务（身故/伤残）",
		  minWidth: 200,
		},
        {
            prop: 'beginTime',
            label: '内保起期',
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '内保止期',
            minWidth: 200
        }
    ]
}

export default {}